module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-portlet-header ui-widget-header ui-corner-all">\n  <span class=\'ui-icon ui-icon-minusthick\'></span>\n  <span class="phx-porlet-title"></span>\n</div>\n<div class="phx-portlet-div">\n  <div class="phx-portlet-content">Lorem ipsum dolor sit amet, consectetuer adipiscing elit</div>\n</div>';
}
return __p;
};
